var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCrossRedFilledIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00021 0.231934C3.53405 0.231934 0.7323 3.03369 0.7323 6.49984C0.7323 9.96599 3.53405 12.7677 7.00021 12.7677C10.4664 12.7677 13.2681 9.96599 13.2681 6.49984C13.2681 3.03369 10.4664 0.231934 7.00021 0.231934ZM10.1342 8.75002L9.25039 9.6338L7.00021 7.38362L4.75003 9.6338L3.86625 8.75002L6.11643 6.49984L3.86625 4.24966L4.75003 3.36589L7.00021 5.61607L9.25039 3.36589L10.1342 4.24966L7.88398 6.49984L10.1342 8.75002Z",
    fill: "#E15554"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrossRedFilledIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cross_Red_Filled_Icon.d164fe63.svg";
export { ForwardRef as ReactComponent };